






















import Vue from "vue";
import iwTopNavigation from "./shared/components/TopNavigation/TopNavigation.vue";
import iwFooter from "./shared/components/Footer.vue";
import iwLoginModal from "@/views/LoginModal.vue";
import iwDialogs from "@/shared/components/Dialogs.vue";
import {authenticate} from "@/shared/scripts/Authenticate";
import "./assets/sass/app.scss";
import { mapGetters, mapState } from "vuex";
import { setLayoutOffset } from "./encoding/scripts/layout";

export default Vue.extend({
    name: "App",
    components: {
        iwTopNavigation: iwTopNavigation,
        iwFooter: iwFooter,
        iwLoginModal: iwLoginModal,
        iwDialogs: iwDialogs
    },

    data: function() {
        return {
            isMobile: true,
        };
    },

    computed: {
        ...mapState("UserModule", ["user"]),
        ...mapGetters({
            isMasquerading: "UserModule/isMasquerading",
        }),
    },

    watch:{
        $route: function() {
            this.computeLayout();
        }
    },

    mounted: function() {
        this.$responsive.registerMediaQuery("from-desktop", () => {
            this.isMobile = false;
        }, () => {
            this.isMobile = true;
        });

        window.addEventListener("resize", () => {
            this.computeLayout();
        });

        authenticate();
    },

    methods: {
        computeLayout: function() {
            Vue.nextTick(() => {
                setLayoutOffset(this.isMobile, this.isMasquerading);
            });
        }
    },
});
